/**
 * Thin NP Productivity Timeline controller. Forwards UI calls to the service
 * unchanged. Per the project's hexagonal rules: controllers are thin; all
 * business logic lives in the service.
 *
 * Type lives in
 * `src/hexagon/adapters/types/npProductivityTimelineController.d.ts`.
 */

export const NpProductivityTimelineControllerFactory = ({
  npProductivityTimelineService,
}: {
  npProductivityTimelineService: INpProductivityTimelineService;
}): INpProductivityTimelineController => ({
  getTimeline: npProductivityTimelineService.getTimeline,
  getWindowSummary: npProductivityTimelineService.getWindowSummary,
});
